export const OPEN_INTERCOM_CHAT_WINDOW = '@support/OPEN_INTERCOM_CHAT_WINDOW';
